export default "__VITE_ASSET__B3lrLabQ__"